import {Address} from '@spartacus/core';


const getLineAddress = (address: Address) => {
  return (address?.line1 ? address.line1 + ' ' : '') + (address?.line2 ? address.line2 : '');
};

const getAddressValues = (address: Address, field: string) => {
  return (address?.[field] ? address[field]  : '');
};


const getAddressCountryValue = (address: Address) => {
  return (address?.country?.name ? address.country.name  : '');
};

export const firstnameLastnameFormatter = (data: any) => {
  return (data?.firstName ? data.firstName : '');
};


export const addressFormatter = (address: Address) => {
  const formattedAddress = [
    firstnameLastnameFormatter(address)
  ];

  if (!address?.formattedAddress) {
    formattedAddress.push(
      getLineAddress(address),
      `${getAddressValues(address, 'town')}, ${getAddressValues(address, 'postalCode')}  ${getAddressCountryValue(address)}`
    );
  } else {
    formattedAddress.push(address.formattedAddress);
  }
  return formattedAddress;
};

